import React, { useState, useEffect } from 'react'
import { TabbedPage, Tab } from 'components/Shared/TabbedPage'
import OpenIssuesGrid from './OpenIssuesGrid'
import IssueDetails from './IssueDetails'
import CompletedIssuesGrid from './CompletedIssuesGrid'
import { useAppContext } from 'hooks/useAppContext'
import { getIssuesByID, Issues as Issue } from 'utils/IssuesUtil'
import { FormProvider } from 'context/FormContext'
import SkeletonGrid from 'components/Shared/SkeletonGrid'


const tabs = [
  new Tab({ label: "Issues", value: "open", scope: "Issues", action: "read" }),
  new Tab({ label: "Resolved", value: "completed", scope: "Issues", action: "read" })
]

function find (obj, id) {
  let result = []
  if (obj.IssueId === id) return [id]
  for (let element of obj.children)
    result = result.concat(find(element, id))
  if (result.length > 0) result.push(obj)
  return result
}

const Issues = ({customFilter}) => {
  const [activeTab, setActiveTab] = useState("open")
  const { currentModule, currentModuleFilter, subModule1, subModule1Filter } = useAppContext() //Getting the App Context
  const [issue, setIssue] = useState({})
  const { selectedProject } = useAppContext() //Getting the App Context
  const [parents, setParents] = useState([])
  const [reloadDate, setReloadDate] = useState(new Date())
  const [loading, setLoading] = useState(false)
  const [loadedFilter, setLoadedFilter] = useState(null) // Track which filter we've finished loading


  useEffect(() => {
    // Reset loadedFilter when navigating away from details view
    if (currentModuleFilter == null) {
      setLoadedFilter(null);
      return;
    }

    if (currentModuleFilter != null && (currentModule.toLowerCase() === "issues" || currentModule.toLowerCase() === "inspections")) {
      let focusedIssueId;
      if(currentModule.toLowerCase() === "issues" && currentModuleFilter && !subModule1) {
        focusedIssueId = currentModuleFilter;
      } else if(subModule1 && subModule1.toLowerCase() === "issues" && subModule1Filter) {
        focusedIssueId = subModule1Filter;
      } else {
        return;
      };

      setLoading(true);
      setParents([]);
      getIssuesByID(0, 10, undefined, undefined, {status: "Open"}, selectedProject, "Open",
        [{ defaults: { projectId: selectedProject, ...customFilter } }]).then((data) => {
        if (data.items.length > 0) {
          for (let i = 0; i < data.roots.length; i++) {
            const findingParent = find(data.roots[i], focusedIssueId)
            if (findingParent.length > 1) {
              findingParent.shift()
              setParents(findingParent)
              break
            }
            if (findingParent.length === 1) {
              setParents([data.items.find(obj => obj.IssueId === focusedIssueId)])
              break;
            }
          };
          const issue_var = data.items.find(obj => obj.IssueId === focusedIssueId);
          const __issue = data.allData.find(obj => obj.IssueId === focusedIssueId);
          const _issue = new Issue(__issue);
          _issue.children = issue_var.children;
          _issue.roots = issue_var.roots;
          _issue.map = issue_var.map;
          setIssue(_issue);
        }
      }).finally(() => {
        setLoading(false);
        setLoadedFilter(focusedIssueId); // Mark that we've finished loading this filter
      })
    }
  }, [currentModule, currentModuleFilter, reloadDate, selectedProject, subModule1, subModule1Filter])

  // Show loading when explicitly loading OR when we have a filter but haven't finished loading for it yet
  const shouldShowLoading = loading || (currentModule === "Issues" && currentModuleFilter !== null && loadedFilter !== currentModuleFilter);

  return (
    <div>
      {shouldShowLoading ? (
        <SkeletonGrid title="Issues" />
      ) : (currentModule === "Issues" && currentModuleFilter !== null && issue !== undefined && Object.keys(issue).length !== 0 && parents.length > 0) ? (
        <div>
          <FormProvider><IssueDetails issue={issue} reloadDate={reloadDate} parents={parents} reload={setReloadDate} /></FormProvider>
        </div>
      ) : (
        <TabbedPage
          tabs={tabs}
          activeTab={activeTab}
          tabSetterFunc={setActiveTab}
        >
          {(() => {
            switch (activeTab) {
              case "open": return <FormProvider><OpenIssuesGrid customFilter={customFilter} /></FormProvider>
              case "completed": return <CompletedIssuesGrid />
              default: return <OpenIssuesGrid customFilter={customFilter} />
            }
          })()}
        </TabbedPage>
      )}
    </div>
  )
}


export  default Issues